"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateFontStyle = void 0;
var _DOM = require("../../../Utils/DOM");
var updateFontStyle = exports.updateFontStyle = function updateFontStyle(content) {
  var fontItem = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var wrapper = document.createElement('div');
  wrapper.innerHTML = content;
  var family = fontItem.family,
    bold = fontItem.bold,
    italic = fontItem.italic,
    boldItalic = fontItem.boldItalic;
  (0, _DOM.traverse)(wrapper, function (node) {
    if (node.style) {
      var style = node.style;
      style.fontFamily = family;
      if (!bold && style.fontWeight || !boldItalic && style.fontStyle) {
        style.fontWeight = '';
      }
      if (!italic && style.fontStyle || !boldItalic && style.fontWeight) {
        style.fontStyle = '';
      }
    }
  });
  return wrapper.innerHTML;
};